import $ from 'jquery';
import Swal from 'sweetalert2';
import {
  removePageIndex,
  updatePageNumbers,
  deleteEditorPage,
  addPagesToSidebar,
  goToPage,
} from '~src/multipages';
import { onErrorShowMessage } from '~src/errors';
import { getState, getStatePure, modifyState } from '~src/state';

export const handleDeletePageBtn = (event) => {
  event.preventDefault();
  const currentPageIndex = getState('currentPageIndex');
  const pages = getStatePure('pages');

  const editorPageIndex = $(event.currentTarget).data('page-btn-index');
  const editorPageId = $(event.currentTarget).data('page-id');
  const editorPageUrl = $(event.currentTarget).data('page-url');

  // Prevent deleting the last page
  if (pages.length === 1) {
    // This never appears but it's here as safeguard
    Swal.fire({
      title: 'Attenzione!',
      text: "Non puoi eliminare l'unica pagina del progetto.",
      icon: 'info',
      confirmButtonColor: '#278e8e',
    });
    return;
  }

  Swal.fire({
    title: 'Sei sicuro?',
    imageUrl: editorPageUrl,
    imageHeight: 150,
    imageAlt: 'Pagina da cancellare',
    text: 'La pagina verrà eliminata definitivamente.',
    type: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#d33',
    cancelButtonText: 'Annulla',
    confirmButtonText: 'Si, elimina',
  }).then(async (result) => {
    if (result.value) {
      Swal.fire({
        text: 'Sto eliminando la pagina...',
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        showConfirmButton: false,
        confirmButtonColor: '#278e8e',
        didOpen: () => {
          Swal.showLoading();
        },
      });

      let returnToIndex;

      // Determine which page to navigate to after deletion
      if (currentPageIndex === editorPageIndex && pages.length > 1) {
        // If deleting the current page, navigate away first
        const isLastPage = editorPageIndex === pages.length - 1;
        const tempNavigateIndex = isLastPage
          ? editorPageIndex - 1
          : editorPageIndex + 1;

        await goToPage(tempNavigateIndex);
      }

      // Calculate the final page index after deletion
      if (editorPageIndex < currentPageIndex) {
        // If deleting a page before current, current index will shift down
        returnToIndex = currentPageIndex - 1;
      } else if (editorPageIndex === currentPageIndex) {
        // If deleting current page
        const isLastPage = editorPageIndex === pages.length - 1;
        returnToIndex = isLastPage ? editorPageIndex - 1 : editorPageIndex;
      } else {
        // If deleting a page after current, current index stays the same
        returnToIndex = currentPageIndex;
      }

      try {
        // First delete from backend
        await deleteEditorPage(window.editorLoader.canvasId, editorPageId);

        // Then update local state
        await removePageIndex(editorPageIndex);
        await updatePageNumbers();

        // Show success message
        Swal.hideLoading();
        Swal.fire({
          title: 'Fatto!',
          html: 'La pagina &egrave; stata eliminata.',
          icon: 'success',
          confirmButtonColor: '#278e8e',
        });

        // Get the updated pages array after deletion
        const updatedPages = getStatePure('pages');

        // Update the sidebar with the new pages array
        await addPagesToSidebar();

        // Update current page index if needed
        if (editorPageIndex < currentPageIndex) {
          // If we deleted a page before the current page, adjust the index
          await modifyState('currentPageIndex', currentPageIndex - 1);
        } else if (
          editorPageIndex === currentPageIndex &&
          updatedPages.length > 0
        ) {
          // If we deleted the current page, set to a valid index
          const newIndex = Math.min(editorPageIndex, updatedPages.length - 1);
          await modifyState('currentPageIndex', newIndex);
        }

        // Navigate to the appropriate page
        const finalCurrentIndex = getState('currentPageIndex');
        if (updatedPages.length > 0 && returnToIndex !== finalCurrentIndex) {
          await goToPage(returnToIndex);
        }
      } catch (error) {
        console.error(error);
        onErrorShowMessage();
      }
    }
  });
};
